<template>
  <div>
    <topbar :title="$t('maps.page-title')" @back="$router.push({name: 'Maps'})" :showBack="true" />

    <template v-if="!loading || true">

      <div class="p-3 mx-auto max-w-3xl w-full md:px-3 xl:max-w-none xl:three-columns xl:grid">
        <div class="xl:col-start-2">

          <div class="space-x-2 justify-items-stretch flex xl:hidden">
            <check-button class="flex-1" radio="one" :showCheck="false" v-model="oneOrAll">una variante</check-button>
            <check-button class="flex-1" radio="all" :showCheck="false" v-model="oneOrAll">tutte le varianti</check-button>
          </div>

          <card type="square" class="rounded-lg">

            <dropdown class="hidden xl:block" innerlabel="Visualizzazione" :outerlabel="oneOrAll === 'one' ? 'Mappa' : 'Grafico'" :enabled="true" ref="oneOrAllDropdown">
              <a
                class="border-t border-line p-3 block"
                @click="oneOrAll = 'one'"
                v-if="oneOrAll === 'all'"
              >Mappa</a>
              <a
                class="border-t border-line p-3 block"
                @click="oneOrAll = 'all'"
                v-if="oneOrAll === 'one'"
              >Grafico</a>
            </dropdown>

            <template v-if="oneOrAll === 'one' && loadeddata">
              <dropdown :outerlabel="showAll ? 'Tutte le varianti' : currentWord.text" innerlabel="Varianti" ref="variants" :enabled="options.length > 0">
                <a
                  class="border-t border-line p-3 block"
                  v-for="option of options"
                  @click="currentWord = option"
                  :key="`vars-${option.id}`"
                >{{option.text}}</a>

                <a 
                  v-if="!showAll && options.length > 0"
                  class="border-t border-line p-3 hidden xl:block w-full focus:outline-none"
                  @click="currentWord = null"
                  :key="`vars----`"
                >Tutte le varianti</a>

              </dropdown>

              <div v-if="url" class="xl:flex">
                <div class="aspect-ratio-16/9 relative xl:w-3/4">
                  <div class="absolute top-0 left-0 w-full h-full overflow-hidden rounded-bl-lg">
                    <wordmap :data="data" />
                  </div>
                </div>
                <div class="xl:w-1/4" v-if="url && url.length === 1">
                  <wordlocations :stats="loadeddata.use[currentWord.id]" />
                </div>
                <div class="xl:w-1/4" v-else-if="url && url.length >= 1">
                  <words-stats :use="loadeddata.use" :options="options" />
                </div>
              </div>
            </template>

            <template v-else-if="loadeddata">
              <variant-stats :stats="loadeddata" />
            </template>
          </card>
        </div>

      </div>
    </template>

  </div>
</template>

<script>
import Wordmap from "@/components/maps/Wordmap";
import Wordlocations from '@/components/maps/Wordlocations';
import { mapActions } from "vuex";
import CheckButton from '@/components/CheckButton.vue';
import VariantStats from '@/components/maps/VariantStats.vue';
import WordsStats from '@/components/maps/WordsStats.vue';
import { statsToPoints } from "@/services/mapdata";

/**@typedef {import('@/services/api').QuestionStats} QuestionStats */

export default {
  components: {
    Wordmap,
    Wordlocations,
    CheckButton,
    VariantStats,
    WordsStats,
  },

  data() {
    return {
      loading: true,
      currentWord: null,
      /**@type QuestionStats|null */
      loadeddata: null,
      oneOrAll: 'one',
      mapdata: null,
    }
  },

  mounted() {
    const id = this.$route.params.id
    if(id) {
      this.fetchData();
    }
  },

  watch: {
    $route(to) {
      if(to.name === 'MapsDetail') {
        this.fetchData();
      }
    },
    currentWord(newid, oldid) {
      if(newid != oldid && this.$refs.variants) {
        this.$refs.variants.close()
      }
    },
    oneOrAll() {
      if(this.$refs.oneOrAllDropdown) {
        this.$refs.oneOrAllDropdown.close()
      }
    }
  },

  methods:{
    ...mapActions("surveys", ["getQuestionStats"]),

    wordTotal(word) {
      return Object.values(this.loadeddata.use[word.id]).reduce((sum, v) => sum + v, 0);
    },

    async fetchData() {
      this.loading = true;
      this.currentWord = null;
      this.loadeddata = null;
      this.mapdata = null;

      const id = this.$route.params.id
      if(id) {
        this.loadeddata = await this.getQuestionStats(parseInt(id));
        const chosen = this.options.find(o => o.used) ?? this.options[0];
        this.currentWord = chosen;

        this.mapdata = this.options.reduce((acc, option) => {
          acc[option.id] = statsToPoints(this.loadeddata.use[option.id]);
          return acc;
        }, {});
      }
      this.loading = false;
    }
  },

  computed: {    
    showAll() {
      return this.currentWord === null && this.loadeddata !== null;
    },

    /** @returns {import('@/services/api').Word[]} */
    options() {
      if(this.loadeddata) {
        return this.loadeddata.options.filter(w => this.loadeddata.use[w.id] !== undefined);
      }
      return [];
    },

    data() {
      if(this.loadeddata) {
        if(this.currentWord) {
          return [this.mapdata[this.currentWord.id]];
        } else {
          return this.options.map(w => this.mapdata[w.id]);
        }
      }
      return null;
    },

    url() {
      if(this.loadeddata) {
        if(this.currentWord) {
          return [this.currentWord.url];
        } else {
          return this.options.map(w => w.url);
        }
      }
      return null;
    },

    voteTotal() {
      return Object.values(this.loadeddata.use)
        .flatMap(v => Object.values(v))
        .reduce((a, b) => a + b, 0);
    },
  },
};
</script>

<style>
</style>